module.exports = __webpack_public_path__ + "img/stay-home.b1cb305f.jpg";